
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.75 6a2.25 2.25 0 014.5 0v.25h-4.5V6zm-1.5 1.75V9a.75.75 0 001.5 0V7.75h4.5V9a.75.75 0 001.5 0V7.75h1.555l.885 11.5H5.81l.885-11.5H8.25zm0-1.5V6a3.75 3.75 0 117.5 0v.25H18a.75.75 0 01.748.692l1 13a.75.75 0 01-.748.808H5a.75.75 0 01-.748-.808l1-13A.75.75 0 016 6.25h2.25z","fill":"#000"}})])
          )
        }
      }
    